var exports = {
  "Z": "Panel__p4IEsb",
  "U": "Content__5Z9wEm",
};

module.exports = exports;
